import { useState, useEffect } from 'react';

export function useIpGeo() {
  const [geo, setGeo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetch('https://ipapi.co/json/')
      .then((r) => {
        if (!r.ok) throw new Error('geo fetch failed');
        return r.json();
      })
      .then((data) => {
        if (cancelled) return;
        setGeo({
          ip: data.ip,
          country_code: data.country_code,
          country_name: data.country_name,
          city: data.city,
          lat: data.latitude,
          lng: data.longitude,
        });
      })
      .catch(() => {
        if (!cancelled) setGeo(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { geo, loading };
}
